let counters = null;

(function galleryScrollInit() {
  // Only initialize scroll behavior on desktop (>= 1024px)
  if (window.innerWidth < 1024) return;

  const thumbs = document.querySelectorAll("[data-thumb-image-index]");
  const targets = document.querySelectorAll("[data-main-image-index]");
  const counters = document.querySelectorAll('[data-track="current"]');

  // Thumbnail click handlers
  thumbs.forEach((thumb) => {
    thumb.addEventListener("click", () => {
      const index = thumb.getAttribute("data-thumb-image-index");
      // Find main image with matching index
      const target = Array.from(targets).find(
        (el) => el.getAttribute("data-main-image-index") === index
      );
      if (!target) return;

      // Get position and scroll
      const targetRect = target.getBoundingClientRect();
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const top = targetRect.top + scrollTop - 4;

      window.scrollTo({
        top,
        behavior: "smooth",
      });
    });
  });

  // Image counter tracking (only on desktop)
  function initImageCounter() {
    if (!targets.length || !counters.length) return;

    const updateCounter = (index) => {
      const paddedIndex = index < 10 ? `0${index}` : `${index}`;
      counters.forEach((counter) => {
        counter.textContent = paddedIndex;
      });
    };

    // Use IntersectionObserver to detect visible images
    const observerOptions = {
      root: null,
      rootMargin: "-40% 0px -40% 0px", // Trigger when image is in center 20% of viewport
      threshold: 0,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Find the img element within the observed container
          const img = entry.target.querySelector
            ? entry.target.querySelector("[data-main-image-index]")
            : null;
          // fallback: entry.target itself might be the img
          const imgEl =
            img ||
            (entry.target.hasAttribute("data-main-image-index")
              ? entry.target
              : null);
          if (imgEl) {
            const index = parseInt(
              imgEl.getAttribute("data-main-image-index"),
              10
            );
            if (!isNaN(index)) {
              updateCounter(index);
            }
          }
        }
      });
    }, observerOptions);

    targets.forEach((target) => {
      const container = target.closest("div");
      if (container) {
        observer.observe(container);
      }
    });

    if (targets.length > 0) {
      const firstIndex = parseInt(
        targets[0].getAttribute("data-main-image-index"),
        10
      );
      if (!isNaN(firstIndex)) {
        updateCounter(firstIndex);
      }
    }
  }

  initImageCounter();
})();

// Initialize Swiper for mobile (< 1024px)
function initProductSwiper() {
  const swiperContainer = document.querySelector(
    '[data-swiper-swiper="product"]'
  );
  const prevButton = document.querySelector('[data-swiper="prev"]');
  const nextButton = document.querySelector('[data-swiper="next"]');
  const counter = document.querySelector('[data-swiper-track="current"]');

  if (!swiperContainer) return;

  function initSwiper() {
    // Check if Swiper is loaded
    if (typeof Swiper === "undefined") {
      setTimeout(initSwiper, 50);
      return;
    }

    // Only initialize on screens smaller than 1024px
    const isMobile = window.innerWidth < 1024;

    if (!isMobile) {
      // Destroy Swiper if it exists and we're on desktop
      if (window.productSwiper) {
        window.productSwiper.destroy(true, true);
        window.productSwiper = null;
      }
      return;
    }

    // Don't reinitialize if already initialized
    if (window.productSwiper) return;

    // Initialize Swiper on the container
    window.productSwiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      on: {
        slideChange: function (swiper) {
          // Update counter - get the data-main-image-index from the active slide
          const activeSlide = swiper.slides[swiper.activeIndex];
          const img = activeSlide
            ? activeSlide.querySelector("[data-main-image-index]")
            : null;
          if (img) {
            const index = parseInt(
              img.getAttribute("data-main-image-index"),
              10
            );
            if (!isNaN(index)) {
              const paddedIndex = index < 10 ? `0${index}` : `${index}`;
              counter.textContent = paddedIndex;
            }
          }
        },
      },
    });

    // Initial counter update
    const activeSlide =
      window.productSwiper.slides[window.productSwiper.activeIndex];
    const img = activeSlide
      ? activeSlide.querySelector("[data-main-image-index]")
      : null;
    if (img) {
      const index = parseInt(img.getAttribute("data-main-image-index"), 10);
      if (!isNaN(index)) {
        const paddedIndex = index < 10 ? `0${index}` : `${index}`;

        if (counters) {
          counters.forEach((counter) => {
            counter.textContent = paddedIndex;
          });
        } else {
          return;
        }
      }
    }
  }

  initSwiper();

  // Reinitialize on resize
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (window.productSwiper) {
        window.productSwiper.destroy(true, true);
        window.productSwiper = null;
      }
      initSwiper();
    }, 250);
  });
}

// Initialize on DOM ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initProductSwiper);
} else {
  initProductSwiper();
}

// Reinitialize on section load (Shopify theme editor)
document.addEventListener("shopify:section:load", (event) => {
  if (event.target.querySelector('[data-swiper-swiper="product"]')) {
    if (window.productSwiper) {
      window.productSwiper.destroy(true, true);
      window.productSwiper = null;
    }
    initProductSwiper();
  }
});

function initAccordionCSS() {
  document
    .querySelectorAll("[data-accordion-css-init]")
    .forEach((accordion) => {
      const closeSiblings =
        accordion.getAttribute("data-accordion-close-siblings") === "true";

      accordion.addEventListener("click", (event) => {
        const toggle = event.target.closest("[data-accordion-toggle]");
        if (!toggle) return; // Exit if the clicked element is not a toggle

        const singleAccordion = toggle.closest("[data-accordion-status]");
        if (!singleAccordion) return; // Exit if no accordion container is found

        const isActive =
          singleAccordion.getAttribute("data-accordion-status") === "active";
        singleAccordion.setAttribute(
          "data-accordion-status",
          isActive ? "not-active" : "active"
        );

        // When [data-accordion-close-siblings="true"]
        if (closeSiblings && !isActive) {
          accordion
            .querySelectorAll('[data-accordion-status="active"]')
            .forEach((sibling) => {
              if (sibling !== singleAccordion)
                sibling.setAttribute("data-accordion-status", "not-active");
            });
        }
      });
    });
}

document.addEventListener("DOMContentLoaded", () => {
  initAccordionCSS();
});

class ImagesZoom extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.normalImages = document.querySelectorAll("[data-product-image]");
    this.scale = 1.8;
  }

  connectedCallback() {
    this.wrapper = this.querySelector("[data-zoom-wrapper]");
    this.currentEl = this.querySelector('[data-zoom="current"]');
    this.totalEl = this.querySelector('[data-zoom="total"]');
    this.closeBtn = this.querySelector('[data-zoom="close"]');
    this.prevBtn = this.querySelector('[data-zoom="prev"]');
    this.nextBtn = this.querySelector('[data-zoom="next"]');
    this.cursor = this.querySelector("[data-zoom-cursor]");
    this.bar2 = this.querySelector('[data-zoom-bar="2"]');

    this.totalEl.textContent = String(this.wrapper.children.length).padStart(
      2,
      "0"
    );

    this.initSwiper();
    this.initZoom();
    this.bindEvents();
    this.initCursor();
  }

  /* ----------------------------------------------
    CURSOR
  ---------------------------------------------- */
  initCursor() {
    if (!this.cursor) return;
    this.addEventListener("mousemove", (e) => this.moveCursor(e));
  }

  moveCursor(e) {
    this.cursor.style.left = e.clientX + "px";
    this.cursor.style.top = e.clientY + "px";
  }

  hideCursor() {
    if (!this.cursor) return;
    gsap.to(this.cursor, { duration: 0.12, scale: 0, ease: "power2.inOut" });
  }

  showCursor() {
    if (!this.cursor) return;
    gsap.to(this.cursor, { duration: 0.12, scale: 1, ease: "power2.inOut" });
  }

  /* ----------------------------------------------
    SWIPER
  ---------------------------------------------- */
  initSwiper() {
    this.swiper = new Swiper(this.querySelector("[data-zoom-swiper]"), {
      slidesPerView: 1,
      on: {
        slideChange: () => {
          this.updateIndex();
          this.resetZoomOnAll();
        },
      },
    });

    this.updateIndex();
  }

  updateIndex() {
    const index = this.swiper.realIndex + 1;
    this.currentEl.textContent = String(index).padStart(2, "0");
  }

  /* ----------------------------------------------
    ZOOM
  ---------------------------------------------- */
  initZoom() {
    this.zoomContainers = this.querySelectorAll(".swiper-zoom-container");

    this.zoomContainers.forEach((container) => {
      const img = container.querySelector("img");

      container.tabIndex = 0;
      container.setAttribute("role", "button");
      container.setAttribute("aria-label", "Zoom image");

      container.addEventListener("click", (e) =>
        this.toggleZoom(container, img, e)
      );
      container.addEventListener("mousemove", (e) =>
        this.moveZoom(container, img, e)
      );
      container.addEventListener("mouseleave", () =>
        this.resetZoom(container, img)
      );

      container.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          this.toggleZoom(container, img, e);
        }
      });
    });
  }

  toggleZoom(container, img, e) {
    const isActive = container.classList.contains("zoom-active");

    if (isActive) {
      this.resetZoom(container, img);
      return;
    }

    this.resetZoomOnAll();
    container.classList.add("zoom-active");
    this.updateZoomUI(true);

    const rect = container.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width;
    const y = (e.clientY - rect.top) / rect.height;

    img.style.transition = "transform 0.15s ease-out";
    this.applyZoomTransform(container, img, x, y);
  }

  moveZoom(container, img, e) {
    if (!container.classList.contains("zoom-active")) return;

    const rect = container.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width;
    const y = (e.clientY - rect.top) / rect.height;

    this.applyZoomTransform(container, img, x, y);
  }

  applyZoomTransform(container, img, relX, relY) {
    const rect = container.getBoundingClientRect();
    const scaledW = rect.width * this.scale;
    const scaledH = rect.height * this.scale;

    const offsetX = (relX - 0.5) * scaledW;
    const offsetY = (relY - 0.5) * scaledH;

    const maxX = (scaledW - rect.width) / 2;
    const maxY = (scaledH - rect.height) / 2;

    const x = Math.max(-maxX, Math.min(maxX, offsetX));
    const y = Math.max(-maxY, Math.min(maxY, offsetY));

    img.style.transform = `translate(${-x}px, ${-y}px) scale(${this.scale})`;
  }

  resetZoom(container, img) {
    container.classList.remove("zoom-active");
    img.style.transform = "translate(0,0) scale(1)";
    this.updateZoomUI(false);
  }

  resetZoomOnAll() {
    this.zoomContainers.forEach((container) => {
      const img = container.querySelector("img");
      container.classList.remove("zoom-active");
      img.style.transform = "translate(0,0) scale(1)";
    });
    this.updateZoomUI(false);
  }

  /* ----------------------------------------------
    ZOOM UI
  ---------------------------------------------- */
  updateZoomUI(isZoomed) {
    if (!this.bar2) return;
    gsap.to(this.bar2, {
      duration: 0.1,
      rotate: isZoomed ? 180 : 90,
      ease: "power1.inOut",
    });
  }

  /* ----------------------------------------------
    EVENTS
  ---------------------------------------------- */
  bindEvents() {
    this.prevBtn.addEventListener("click", () => this.swiper.slidePrev());
    this.nextBtn.addEventListener("click", () => this.swiper.slideNext());

    this.closeBtn.addEventListener("click", () => this.close());
    this.closeBtn.addEventListener("mouseenter", () => this.hideCursor());
    this.closeBtn.addEventListener("mouseleave", () => this.showCursor());

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") this.close();
      if (e.key === "ArrowLeft") this.swiper.slidePrev();
      if (e.key === "ArrowRight") this.swiper.slideNext();
    });

    this.normalImages.forEach((image) => {
      image.addEventListener("click", () => {
        const index = Number(image.getAttribute("data-product-image")) - 1;
        this.open(index);
      });
    });
  }

  /* ----------------------------------------------
    OPEN / CLOSE
  ---------------------------------------------- */
  open(index) {
    this.classList.remove("hidden");
    document.body.style.overflow = "hidden";
    this.swiper.slideTo(index);
    this.resetZoomOnAll();
  }

  close() {
    this.classList.add("hidden");
    document.body.style.overflow = "auto";
    this.resetZoomOnAll();
  }
}

customElements.define("images-zoom", ImagesZoom);

class CompleteTheLook extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.container = this.querySelector("[data-swiper-ctl-container]");
    this.onResize = this.onResize.bind(this);

    this.slides = this.querySelectorAll(".swiper-slide");
  }

  connectedCallback() {
    if (!this.container) return;

    this.slides.forEach((slide) => {
      this.onSlideHover(slide);
    });

    this.check();
    window.addEventListener("resize", this.onResize);
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.onResize);
    if (this.swiper) this.swiper.destroy(true, true);
  }

  onResize() {
    this.check();
  }

  check() {
    const shouldInit = window.innerWidth < 1024;

    if (shouldInit && !this.swiper) {
      this.swiper = new Swiper(this.container, {
        slidesPerView: 2,
        spaceBetween: 4,
        pagination: {
          el: this.querySelector("[data-ctl-swiper-pagination]"),
          bulletClass: "swiper-pagination-bullet",
          bulletActiveClass: "swiper-pagination-bullet-active",
        },
      });
    }

    if (!shouldInit && this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  onSlideHover(productCard) {
    const content = productCard.querySelector("[data-ctl-content]");

    content.classList.remove("top-[50vh]");

    productCard.addEventListener("mousemove", (e) => {
      const rect = productCard.getBoundingClientRect();
      const offsetY = e.clientY - rect.top;

      content.style.transform = `translateY(${offsetY + 24}px)`;
    });

    productCard.addEventListener("mouseleave", () => {
      content.style.transform = "";
    });
  }
}

customElements.define("complete-the-look", CompleteTheLook);

class SizeGuideButton extends HTMLElement {
  constructor() {
    super();

    this.sizeGuide = document.querySelector("size-guide");
    console.log(this.sizeGuide);
    this.closeBtn = this.sizeGuide.querySelector('[data-size-guide="close"]');
  }

  connectedCallback() {
    this.closeBtn.addEventListener("click", () => {
      this.close();
    });

    this.addEventListener("click", () => {
      this.open();
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") this.close();
    });
  }

  close() {
    this.sizeGuide.classList.add("hidden");
    document.body.style.overflow = "auto";
  }

  open() {
    this.sizeGuide.classList.remove("hidden");
    document.body.style.overflow = "hidden";
  }
}

customElements.define("size-guide-button", SizeGuideButton);
